import ReactGA from 'react-ga4';

const isProductionURL =
  typeof window !== 'undefined' &&
  window.location.hostname === 'assistant.thisandthat.chat';

interface GA4EventParams {
  category: string;
  action: string;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
  transport?: 'beacon' | 'xhr' | 'image';
  [key: string]: any;
}

interface GA4PageViewParams {
  hitType: 'pageview';
  page: string;
  title?: string;
}

export function trackGA4Event(params: GA4EventParams): void {
  if (!isProductionURL) {
    return;
  }

  ReactGA.event(params);
}

export function sendGA4PageView(params: GA4PageViewParams): void {
  if (!isProductionURL) {
    return;
  }

  ReactGA.send(params);
}

export function setGA4UserProperty(property: string, value: any): void {
  if (!isProductionURL) {
    return;
  }

  ReactGA.set({ [property]: value });
}
